<template>
    <div class="search-box">
        <div class="od-search__backdrop" v-show="isSearchFocused" @click="setIsSearchFocused(false)"></div>
        <div class="header-search-close__wrapper" v-show="isSearchFocused">
            <div class="header-search-close" @click="setIsSearchFocused(false)">
                <div class="header-search-close__inner">
                    <svg class="header-search-close__icon">
                        <use xlink:href="#svg_close" xmlns:xlink="http://www.w3.org/1999/xlink"></use>
                    </svg>
                </div>
            </div>
        </div>

        <div class="search-box__input-group">
            <input :placeholder="inputPlaceholder" type="text" class="search-box__input" :value="currentSearchString"
                @focus="setIsSearchFocused(true)" @blur="removeFocus" @input="setIsSearchFocused(true, $event)"
                @keyup.enter="search()" autocomplete="off">

            <button class="search-box__button" type="submit" @click="search()">
                <svg class="search__icon">
                    <use xlink:href="#svg_search" xmlns:xlink="http://www.w3.org/1999/xlink"></use>
                </svg>
            </button>
        </div>

        <div class="search-autocomplete" :class="{ 'search-autocomplete--active': isSearchOpen }">
            <div class="search-autocomplete__head"><span v-html="searchHeadlineString"></span></div>

            <div class="search-autocomplete__body-autocomplete search-autocomplete__body-autocomplete--active">
                <div v-if="articleApiLoading" class="search-autocomplete__loading"></div>

                <div v-if="!articleApiLoading && autocompleteResult.length > 0"
                    class="search-autocomplete__body-categories">
                    <template v-if="autocompleteResult.length > 0">
                        <div class="search-autocomplete__headline search-autocomplete__headline--search">{{
                            searchKeywordString }}</div>
                        <div class="search-autocomplete__keywords">
                            <div class="search-autocomplete__keyword" v-for="keyword in autocompleteKeywords">
                                <span v-html="keyword"></span>
                            </div>
                        </div>
                    </template>
                    <div class="search-autocomplete__mdup-cats">
                        <div class="search-autocomplete__headline">{{ searchCategoryString }}</div>
                        <div class="search-autocomplete__categories">
                            <div class='search-autocomplete__item search-autocomplete__item--article-view'
                                v-for="result in autocompleteCategories">
                                <a class='search-autocomplete__item-inner' :href='result.url'>
                                    <div class='search-autocomplete__img'>
                                        <img :src="result.image" />
                                    </div>
                                    {{ result.name }}<i class='fa fa-chevron-right'></i>
                                </a>
                            </div>
                        </div>
                    </div>
                </div>
                <div v-else-if="!articleApiLoading && autocompleteResult.length == 0"
                    class="search-autocomplete__body-categories">
                    <template v-if="autocompleteResult.length == 0">
                        <div class="search-autocomplete__headline search-autocomplete__headline--search">{{
                            searchKeywordString }}</div>
                        <div class="search-autocomplete__keywords">
                            <div class="search-autocomplete__keyword" v-for="keyword in autocompleteKeywords">
                                <span v-html="keyword"></span>
                            </div>
                        </div>
                    </template>
                </div>
                <div v-if="!articleApiLoading && autocompleteResult.length > 0"
                    class="search-autocomplete__body-article">
                    <div class="search-autocomplete__headline"><!--{{ searchArticleString }}--> <a
                            :href="'/search?query=' + currentSearchString"><u v-html="searchShowAll"></u></a></div>
                    <div class="search-autocomplete__article" v-for="result in autocompleteResult">
                        <a class="search-autocomplete__article-inner" :href="result.url">
                            <div class="search-autocomplete__article-image"><img :src="result.mainImage"></div>
                            <div class="search-autocomplete__article-name">
                                <span>{{ result.name }}</span>
                                <div class="search-autocomplete__article-price-wrapper d-flex">
                                    <span class="search-autocomplete__article-cross-price w-auto" v-if="result.rrp">{{
                                        result.rrp
                                    }}</span>
                                    <span class="search-autocomplete__article-price">{{ result.price }}</span>
                                </div>
                            </div>
                        </a>
                    </div>
                </div>
                <div v-if="!articleApiLoading && autocompleteResult.length == 0"
                    class="search-autocomplete__body-article">
                    {{ $translate("Weberbuero::Template.searchNothingFound") }}
                </div>
                <div class="search-autocomplete__mobile-cats"
                    v-if="!articleApiLoading && autocompleteResult.length > 0">
                    <div class="search-autocomplete__headline">{{ searchCategoryString }}</div>
                    <div class="search-autocomplete__categories">
                        <div class='search-autocomplete__item search-autocomplete__item--article-view'
                            v-for="result in autocompleteCategories">
                            <a class='search-autocomplete__item-inner' :href='result.url'>
                                <div class='search-autocomplete__img'>
                                    <img :src="result.image" />
                                </div>
                                {{ result.name }}<i class='fa fa-chevron-right'></i>
                            </a>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import ApiService from "ceres/app/services/ApiService";
import TranslationService from "ceres/app/services/TranslationService";
import UrlService from "ceres/app/services/UrlService";
import { mapState } from "vuex";

export default {
    name: "ODSearch",
    props: {
        categories:
        {
            type: Array,
            default: []
        },
    },
    created() {
        this.$options.template = this.template;

    },
    mounted() {

        this.$nextTick(() => {

            const urlParams = UrlService.getUrlParams(document.location.search);

            this.$store.commit("setItemListSearchString", urlParams.query);

            if (typeof (urlParams.query) != "undefined") {
                this.currentSearchString = urlParams.query;
            }

            var rawFile = new XMLHttpRequest();
            rawFile.open("GET", this.filename, true);

            let that = this;

            rawFile.onreadystatechange = function () {
                if (rawFile.readyState === 4) {
                    if (rawFile.status === 200 || rawFile.status == 0) {
                        const allText = rawFile.responseText;

                        that.keywordArr = allText.split("\n");

                    }
                }
            }
            rawFile.send(null);

            this.$store.dispatch("loadPartialNavigationTree", null, true)
                .then(response => {
                    this.$store.commit("setNavigationTree", response);
                });
        });

    },
    data() {
        return {
            currentSearchString: "",
            checkCurrentSearchString: "",
            autocompleteResult: [],
            autocompleteCategories: [],
            autocompleteKeywords: [],
            keywordArr: [],
            autocompletePrevCategories: [],
            isSearchFocused: false,
            promiseCount: 0,
            selectedAutocompleteIndex: -1,
            searchHeadlineString: TranslationService.translate("Weberbuero::Template.searchHeadlineCategory"),//"Suche nach Kategorien",
            searchCategoryString: TranslationService.translate("Weberbuero::Template.searchHeadlineGoToCategory"),//"zur Kategorie",
            searchArticleString: TranslationService.translate("Weberbuero::Template.searchProducts"),//"Produkte",
            searchKeywordString: TranslationService.translate("Weberbuero::Template.searchSuggestions"),//"Suchvorschläge",
            articleApiLoading: true,
            filename: App.language !== 'de' ? "https://cdn02.plentymarkets.com/2gnme0xtljk4/frontend/keywords/Keywordliste_" + App.language + ".csv" : "https://cdn02.plentymarkets.com/2gnme0xtljk4/frontend/keywords/Keywordliste.csv"

        };
    },
    methods:
    {
        getCategoryUrl(url) {
            const trailingSlash = url[0] === "/" ? "" : "/";
            const prefix = this.includeLanguage ? `/${App.language}${trailingSlash}` : "";

            return '/' + prefix + url;
        },

        getKewords() {
            this.autocompleteKeywords = [];
            let that = this;
            let searchBaseURL = "/search?query=";
            if (App.defaultLanguage !== App.language) {
                searchBaseURL = `/${App.language}/search?query=`;
            }

            this.keywordArr.forEach(function (e) {

                if ((e.indexOf(that.currentSearchString) != -1 || e.toLowerCase().indexOf(that.currentSearchString) != -1) &&
                    (that.autocompleteKeywords.indexOf(e) == -1 || that.autocompleteKeywords.indexOf(e.toLowerCase()) == -1) && that.autocompleteKeywords.length <= 10) {
                    let re = new RegExp(that.currentSearchString, 'g');
                    let highlight = e.replace(re, '<b>' + that.currentSearchString + '</b>');
                    if (highlight == e) {
                        highlight = e.toLowerCase().replace(re, '<b>' + that.currentSearchString + '</b>');
                        highlight = highlight.charAt(0).toUpperCase() + highlight.slice(1);
                    }
                    that.autocompleteKeywords.push("<a href='" + searchBaseURL + e + "'>" + highlight + "</a>");
                }

            });
        },
        search() {
            if (this.currentSearchString.length) {
                if (document.location.pathname === "/search") {
                    //this.updateTitle(this.currentSearchString);
                    this.$store.dispatch("searchItems", this.currentSearchString);

                    this.selectedAutocompleteIndex = -1;
                    this.autocompleteResult = [];
                }
                else {
                    let searchBaseURL = "/search?query=";

                    if (App.defaultLanguage !== App.language) {
                        searchBaseURL = `/${App.language}/search?query=`;
                    }

                    window.open(searchBaseURL + this.currentSearchString, "_self", false);
                }
            }
            else {
                this.preventSearch = false;
            }
        },
        removeFocus() {
            // add a focused class to the body to determine when the keyboard is opened
            document.querySelector("body").classList.remove("focused");
        },
        setIsSearchFocused(isActive, eventObject) {
            this.isSearchFocused = isActive;

            if (eventObject) {
                this.currentSearchString = eventObject.target.value;
            }

            if (isActive) {
                if (document.querySelector("body").classList.contains("is-ios")) {
                    document.querySelector("body").classList.add("focused")
                }
                if (this.currentSearchString.length >= 3 && this.currentSearchString != this.checkCurrentSearchString) {
                    this.autocomplete(this.currentSearchString);
                }
            } else {
                document.querySelector("body").classList.remove("search-open");
            }

        },
        autocomplete(searchString) {
            this.articleApiLoading = true;
            this.getKewords();

            if (this.promiseCount >= Number.MAX_SAFE_INTEGER) {
                this.promiseCount = 0;
            }

            const promiseCount = ++this.promiseCount;
            var t0 = performance.now();
            ApiService.get("/rest/weberbuero/item/search/autocomplete", { query: searchString })
                .done(response => {
                    var t1 = performance.now();
                    console.log("Call to doSomething took " + (t1 - t0) + " milliseconds.");
                    if (this.promiseCount === promiseCount) {
                        this.transformAutocomplete(response, searchString);
                        this.articleApiLoading = false;
                    }
                }).fail((d, err) => console.log(d, err));

            this.checkCurrentSearchString = this.currentSearchString;
        },


        // transform the autocomplete result to usable object
        transformAutocomplete(data, searchString) {
            this.autocompleteResult = [];
            this.selectedAutocompleteIndex = -1;
            this.autocompleteCategories = [];

            let outputCatTmp = [];

            if (data && (typeof data.documents !== "undefined") && data.documents.length) {
                for (const item of data.documents.slice(0, 8)) {
                    const imagesArr = this.$options.filters.itemImages(item.data.images, "urlSecondPreview");

                    let mainImage = item.data.images.all[0].urlSecondPreview


                    let lowestPosition = Infinity;

                    for (let key in item.data.images.all) {
                        const image = item.data.images.all[key];
                        if (image.position < lowestPosition) {
                            lowestPosition = image.position;
                            mainImage = image.urlSecondPreview;
                        }
                    }

                    //const images = this.$options.filters.itemImage(imagesArr);
                    const url = this.$options.filters.itemURL(item.data);
                    const name = this.$options.filters.itemName(item.data);

                    // filter RRP and default Price
                    const defaultPrice = item.data.salesPrices.find(p => p.type === "default");
                    const rrpPrice = item.data.salesPrices.find(p => p.type === "rrp");
                    // move stringreplace to frontend
                    const price = (defaultPrice.price).replace(".", ",") + " €";
                    const rrp = rrpPrice && parseFloat(rrpPrice.price) > 0 ? (rrpPrice.price).replace(".", ",") + " €" : "";

                    let displayName = name;

                    for (const split of searchString.split(" ")) {
                        displayName = displayName.replace(split, `<strong>${split}</strong>`);
                    }


                    this.autocompleteResult.push({
                        mainImage,
                        url,
                        name,
                        displayName,
                        price,
                        rrp
                    });


                    if (typeof (item.data.defaultCategories) != "undefined" && typeof (item.data.defaultCategories[0]) != "undefined") {
                        if (outputCatTmp.indexOf(item.data.defaultCategories[0].id) == -1) {
                            outputCatTmp.push(item.data.defaultCategories[0].id);
                        }
                    }


                }

                // Kategorien laden
                let outputCats = new Array();
                let them = this;

                this.navigationTree.forEach(function (category, index) {
                    let categoryUrl = category.details[0].nameUrl;

                    if (outputCatTmp.indexOf(category.id) > -1) {
                        if (typeof (outputCats[category.id]) == "undefined") {
                            outputCats[category.id] = category;
                            outputCats[category.id]["url"] = them.getCategoryUrl(categoryUrl);
                        }
                    }

                    if (category.childCount > 0) {
                        category.children.forEach(function (category2, index2) {
                            let categoryUrl2 = categoryUrl + "/" + category2.details[0].nameUrl;

                            if (outputCatTmp.indexOf(category2.id) > -1) {
                                if (typeof (outputCats[category.id]) == "undefined") {
                                    outputCats[category.id] = category;
                                    outputCats[category.id]["url"] = them.getCategoryUrl(categoryUrl);
                                }
                                if (typeof (outputCats[category2.id]) == "undefined") {
                                    outputCats[category2.id] = category2;
                                    outputCats[category2.id]["url"] = them.getCategoryUrl(categoryUrl2);
                                }
                            }

                            if (category2.childCount > 0) {
                                category2.children.forEach(function (category3, index3) {
                                    let categoryUrl3 = categoryUrl2 + "/" + category3.details[0].nameUrl;

                                    if (outputCatTmp.indexOf(category3.id) > -1) {

                                        if (typeof (outputCats[category.id]) == "undefined") {
                                            outputCats[category.id] = category;
                                            outputCats[category.id]["url"] = them.getCategoryUrl(categoryUrl);
                                        }
                                        if (typeof (outputCats[category2.id]) == "undefined") {
                                            outputCats[category2.id] = category2;
                                            outputCats[category2.id]["url"] = them.getCategoryUrl(categoryUrl2);
                                        }

                                        if (typeof (outputCats[category3.id]) == "undefined") {
                                            outputCats[category3.id] = category3;
                                            outputCats[category3.id]["url"] = them.getCategoryUrl(categoryUrl3);
                                        }
                                    }

                                    if (category3.childCount > 0) {
                                        category3.children.forEach(function (category4, index4) {
                                            let categoryUrl4 = categoryUrl3 + "/" + category4.details[0].nameUrl;

                                            if (outputCatTmp.indexOf(category4.id) > -1) {
                                                if (typeof (outputCats[category.id]) == "undefined") {
                                                    outputCats[category.id] = category;
                                                    outputCats[category.id]["url"] = them.getCategoryUrl(categoryUrl);
                                                }
                                                if (typeof (outputCats[category2.id]) == "undefined") {
                                                    outputCats[category2.id] = category2;
                                                    outputCats[category2.id]["url"] = them.getCategoryUrl(categoryUrl2);
                                                }

                                                if (typeof (outputCats[category3.id]) == "undefined") {
                                                    outputCats[category3.id] = category3;
                                                    outputCats[category3.id]["url"] = them.getCategoryUrl(categoryUrl3);
                                                }
                                                if (typeof (outputCats[category4.id]) == "undefined") {
                                                    outputCats[category4.id] = category4;
                                                    outputCats[category4.id]["url"] = them.getCategoryUrl(categoryUrl4);
                                                }
                                            }

                                            if (category4.childCount > 0) {
                                                category4.children.forEach(function (category5, index5) {
                                                    let categoryUrl5 = categoryUrl4 + "/" + category5.details[0].nameUrl;

                                                    if (outputCatTmp.indexOf(category5.id) > -1) {
                                                        if (typeof (outputCats[category.id]) == "undefined") {
                                                            outputCats[category.id] = category;
                                                            outputCats[category.id]["url"] = them.getCategoryUrl(categoryUrl);
                                                        }
                                                        if (typeof (outputCats[category2.id]) == "undefined") {
                                                            outputCats[category2.id] = category2;
                                                            outputCats[category2.id]["url"] = them.getCategoryUrl(categoryUrl2);
                                                        }

                                                        if (typeof (outputCats[category3.id]) == "undefined") {
                                                            outputCats[category3.id] = category3;
                                                            outputCats[category3.id]["url"] = them.getCategoryUrl(categoryUrl3);
                                                        }
                                                        if (typeof (outputCats[category4.id]) == "undefined") {
                                                            outputCats[category4.id] = category4;
                                                            outputCats[category4.id]["url"] = them.getCategoryUrl(categoryUrl4);
                                                        }
                                                        if (typeof (outputCats[category5.id]) == "undefined") {
                                                            outputCats[category5.id] = category5;
                                                            outputCats[category5.id]["url"] = them.getCategoryUrl(categoryUrl5);
                                                        }
                                                    }

                                                    if (category5.childCount > 0) {
                                                        category5.children.forEach(function (category6, index6) {
                                                            let categoryUrl6 = categoryUrl5 + "/" + category6.details[0].nameUrl;

                                                            if (outputCatTmp.indexOf(category6.id) > -1) {
                                                                if (typeof (outputCats[category.id]) == "undefined") {
                                                                    outputCats[category.id] = category;
                                                                    outputCats[category.id]["url"] = them.getCategoryUrl(categoryUrl);
                                                                }
                                                                if (typeof (outputCats[category2.id]) == "undefined") {
                                                                    outputCats[category2.id] = category2;
                                                                    outputCats[category2.id]["url"] = them.getCategoryUrl(categoryUrl2);
                                                                }

                                                                if (typeof (outputCats[category3.id]) == "undefined") {
                                                                    outputCats[category3.id] = category3;
                                                                    outputCats[category3.id]["url"] = them.getCategoryUrl(categoryUrl3);
                                                                }
                                                                if (typeof (outputCats[category4.id]) == "undefined") {
                                                                    outputCats[category4.id] = category4;
                                                                    outputCats[category4.id]["url"] = them.getCategoryUrl(categoryUrl4);
                                                                }
                                                                if (typeof (outputCats[category5.id]) == "undefined") {
                                                                    outputCats[category5.id] = category5;
                                                                    outputCats[category5.id]["url"] = them.getCategoryUrl(categoryUrl5);
                                                                }
                                                                if (typeof (outputCats[category6.id]) == "undefined") {
                                                                    outputCats[category6.id] = category6;
                                                                    outputCats[category6.id]["url"] = them.getCategoryUrl(categoryUrl6);
                                                                }
                                                            }
                                                        });
                                                    }

                                                });
                                            }

                                        });
                                    }

                                });
                            }
                        });
                    }

                });

                let searchBaseURL = "/search?query=";
                let baseURL = "";
                if (App.defaultLanguage !== App.language) {
                    searchBaseURL = "/${App.language}/search?query=";
                    baseURL = "/${App.language}";
                }

                let acCategories = {};

                let maxArtCatCount = 3;

                if (outputCats.length > 0) {
                    let i = 0;
                    $(outputCats).each(function (index, category) {
                        if (typeof (category) != "undefined" && i < maxArtCatCount) {
                            acCategories[category.id] = {};
                            acCategories[category.id]["name"] = category.details[0].name;
                            acCategories[category.id]["url"] = category.url;
                            acCategories[category.id]["image"] = baseURL + "/documents/" + category.details[0].image2Path;

                            i++;
                        }
                    });

                }
                this.autocompleteCategories = acCategories;
            }
        }
    },

    computed:
    {
        isSearchOpen() {
            return this.currentSearchString.length >= 3 && this.isSearchFocused;
        },
        inputPlaceholder() {
            return TranslationService.translate("Weberbuero::Template.searchPlaceholderString");
        },
        searchShowAll() {
            return TranslationService.translate("Weberbuero::Template.searchShowAll");
        },
        ...mapState({
            navigationTree: state => state.navigation.tree
        })
    },

    watch: {
        isSearchOpen(oldVal, newVal) {
            if (newVal) {
                document.querySelector("body").classList.add("search-open");
            } else {
                document.querySelector("body").classList.remove("search-open");
            }
        }
    }
}
</script>
